import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Header } from 'foundations-components/transitional/components/Header';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentNotFound = () => /*#__PURE__*/_jsxs(View, {
  children: [/*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.title"
    }),
    breadcrumbs: /*#__PURE__*/_jsx(Breadcrumbs, {
      children: /*#__PURE__*/_jsx(UIRouterLink, {
        to: "/",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.error.backToIndexPage"
        })
      })
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      width: 150,
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.error.errorTitle"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.error.errorDescription"
      })
    })]
  })]
});
export default DocumentNotFound;